import Cookies from "universal-cookie";
import { jwtDecode } from "jwt-decode";

const cookies = new Cookies();

const ACCESS_TOKEN_KEY = "sc_accessToken";
const REFRESH_TOKEN_KEY = "sc_refreshToken";

export const getAccessToken = (): string | undefined =>
  cookies.get(ACCESS_TOKEN_KEY);

export const getRefreshToken = (): string | undefined =>
  cookies.get(REFRESH_TOKEN_KEY);

export const setTokens = (accessToken: string, refreshToken?: string) => {
  cookies.set(ACCESS_TOKEN_KEY, accessToken, { path: "/", sameSite: "lax" });
  if (refreshToken) {
    cookies.set(REFRESH_TOKEN_KEY, refreshToken, { path: "/", sameSite: "lax" });
  }
};

export const clearTokens = () => {
  cookies.remove(ACCESS_TOKEN_KEY, { path: "/" });
  cookies.remove(REFRESH_TOKEN_KEY, { path: "/" });
};

export const isJwtExpired = (token: string, leewaySeconds = 30): boolean => {
  try {
    const { exp } = jwtDecode<{ exp: number }>(token);
    if (!exp) return false;
    return Date.now() / 1000 > exp - leewaySeconds;
  } catch {
    return true;
  }
};

export const isAuthed = (): boolean => !!getAccessToken();
